var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkEnglishLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 40,
    viewBox: "0 0 141 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.334 25.897 26.582 37.03l-1.075 2.512h.004c1.936.387 3.93.39 5.926.006 1.541-.386 2.967-1 4.236-1.823.16-.106.316-.212.47-.322l-4.809-11.506z",
    fill: "#73B158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.496 30.784z",
    fill: "#7CBC56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.067 12.616.026 10.09v.002l4.982 1.553 5.259 1.636-10.267-13.281z",
    fill: "#226188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.093 22.708 4.982 1.553-4.982-1.553zM21.063 12.616h.004v-.002h-.004v.002z",
    fill: "#7CBC56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.61.182a12.976 12.976 0 0 0-7.541 4.18c-.225.252-.445.518-.652.79l-.065.09c-.04.053-.077.108-.116.16l10.83 7.212L18.61.182z",
    fill: "#29A5BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.07 28.565 10.716 25.9l-9.022-5.037C.016 23.922-.131 26.699.069 28.565z",
    fill: "#73B158"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.595 17.264.002.003-.002-.003z",
    fill: "#7CBC56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.073 28.626.013.106.023.128c.678 4.004 2.8 6.453 4.263 7.711L10.717 25.9.069 28.565c0 .02.004.041.004.061z",
    fill: "#68A855"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.813 36.933a.68.68 0 0 1 .074.058l.061.046c2.144 1.6 4.206 2.629 7.84 2.82.211.011.425.017.638.017.365 0 .737-.017 1.105-.048-.973-3.58-3.656-13.42-3.815-13.924V25.9L4.372 36.572c.156.133.303.254.442.361z",
    fill: "#5B9E54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.53 39.825.004.002.155-.013.1-.01.133-.015c2.25-.262 4.083-1.048 5.302-1.572.293-.126.55-.237.764-.319-2.477-1.505-4.457-3.37-5.99-5.177v-.002a27.465 27.465 0 0 1-1.927-2.549 29.121 29.121 0 0 1-1.198-1.937c-.232-.41-.44-.777-.588-1.101-.568-1.228-.562-1.213-.568-1.233",
    fill: "#5A9252"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.338 2.437A12.912 12.912 0 0 0 24.42.52 9.514 9.514 0 0 0 21.244.01l-.062-.001a12.722 12.722 0 0 0-2.45.153l-.123.021 2.454 12.432L28.51 2.566c-.057-.043-.112-.087-.172-.129z",
    fill: "#1E98B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.325 9.635a13.032 13.032 0 0 0-4.815-7.068l-7.447 10.047h.004l12.27-2.934-.012-.045z",
    fill: "#218DA5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.83 14.404-.003.166c0-.059.004-.113.004-.166zM21.093 22.706a.818.818 0 0 0-.05.017l.05-.015v-.002z",
    fill: "#7CBC56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.093 22.708a.488.488 0 0 0-.05.015c-.007.001-.01.003 0 0-.523.155-.637.193-10.326 3.176l20.617-.002-5.259-1.636-4.982-1.553z",
    fill: "#95C65B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.044 22.723.049-.015-.05.015z",
    fill: "#7CBC56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.812 15.051-.029.014c-2.574 1.31-4.652 3.22-5.86 5.397l-.017.03c-.073.124-.143.248-.211.372l9.022 5.035L7.812 15.05z",
    fill: "#83BD5C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.067 12.614-10.83-7.212a13.014 13.014 0 0 0-2.461 7.101c0 .012-.067.978.033 2.533 0 .005 0 .008.003.014.266-.134.533-.261.795-.374v-.006.006a24.893 24.893 0 0 1 6.053-1.745 30.64 30.64 0 0 1 2.2-.255c1.438-.114 2.897-.088 4.207-.06v-.002z",
    fill: "#25B3C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.093 22.706-.026-10.089L10.717 25.9c9.689-2.983 9.803-3.023 10.327-3.176-.03.009.042-.015.049-.017z",
    fill: "#9EC95B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.093 22.706-.026-10.09v.001l.026 10.089z",
    fill: "#7CBC56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.716 25.899 10.347-13.282v-.001c-1.306-.029-2.765-.054-4.203.06a27.38 27.38 0 0 0-2.826.361 24.895 24.895 0 0 0-5.427 1.64v-.008.008c-.262.112-.529.239-.795.373H7.81l.003.001L10.716 25.9z",
    fill: "#91C45A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.683 29.58zM11.873 28.233zM12.17 28.747zM11.285 27.132zM11.285 27.132c-.377-.75-.559-1.21-.568-1.228.01.018.19.478.568 1.228z",
    fill: "#7CBC56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.334 25.897a428.776 428.776 0 0 0-3.804 1.55 752.162 752.162 0 0 0-5.727 2.387 1375.08 1375.08 0 0 0-5.663 2.402l-.01.003-1.131.482c1.532 1.807 3.512 3.671 5.989 5.178 1.006.59 2.315 1.078 4.212 1.574l.12.03.009.002.177.037c.026.004-.026-.005 0 0l1.076-2.512 4.752-11.133z",
    fill: "#83BD5C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.803 29.834z",
    fill: "#7CBC56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.717 25.899v.005c.01.02.19.478.568 1.228.157.317.355.69.588 1.101a29.836 29.836 0 0 0 2.586 3.83c.171.218.352.437.54.656l1.13-.48c.005-.001.007-.001.01-.003a1802.392 1802.392 0 0 1 5.663-2.402 749.829 749.829 0 0 1 5.728-2.387 428.776 428.776 0 0 1 3.804-1.55l-20.617.002z",
    fill: "#91C45A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.73 11.918a13.175 13.175 0 0 0-.366-2.135l-.027-.102-12.27 2.933v.002l12.528 4.648.002.002c.027-.258.053-.498.083-.74.066-.527.125-1.36.147-1.956 0-.055.004-.111.004-.166.02-.864-.017-1.698-.102-2.486z",
    fill: "#20839F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.481 26.082a14.44 14.44 0 0 0-.716-3.536l-9.431 3.351 9.759 4.17c.244-.999.51-2.411.388-3.985z",
    fill: "#5B9E54"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m41.093 30.066-9.759-4.169L36.14 37.4c3.42-2.443 4.502-5.738 4.515-5.774.132-.43.237-.797.33-1.148h.003l.033-.133c.006-.026.016-.054.022-.08l.004-.017c.013-.06.03-.12.046-.182z",
    fill: "#68A855"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.067 12.616 10.267 13.281c.013-.028 1.256-2.208 2.261-8.632l-12.528-4.65z",
    fill: "#267491"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.699 22.352c-1.187-3.223-3.398-5.346-5.02-6.461a12.199 12.199 0 0 0-1.861-1.06l.01-.262c-.023.597-.082 1.43-.148 1.957-.03.242-.06.48-.085.74-1.005 6.423-2.248 8.605-2.261 8.631l9.43-3.35-.065-.195z",
    fill: "#5A9252"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m89.587 24.869-3.403-10.273h-2.307l-3.373 10.28-2.673-10.28h-3.343l4.48 14.825h2.653l3.424-10.496 3.423 10.496h2.652l4.452-14.825h-3.314l-2.671 10.273zM56.438 12.084v.515h-.036v10.248c0 2.333-1.184 3.71-3.26 3.818v.005l-.145.002c-.047 0-.095.003-.143 0H51.12c-1.455 0-1.569 1.752-1.569 2.29v.61h3.323c3.408 0 6.846-2.025 6.846-6.553V10.301h-.712c-.602 0-2.57.128-2.57 1.783zM70.508 24.09c0 1.093-.198 1.744-.66 2.177-.791.76-1.62.82-2.62.82-1.578 0-2.52-.78-2.52-2.087 0-1.29.92-2.06 2.462-2.06h3.338v1.15zm-3.01-9.554-.14.001h-.15c-1.193 0-1.958.15-1.966.153-1.07.202-1.589.95-1.589 2.289v.301c.549-.042 1.736-.11 3.709-.11 1.911 0 3.147 1.068 3.147 2.723v1.091h-3.925c-3.01 0-4.88 1.572-4.88 4.103 0 1.287.414 2.425 1.166 3.206.838.84 2.034 1.25 3.656 1.25 1.584 0 2.505-.36 3.513-1.37l.557-.56v1.784h3.062v-9.739c0-3.396-2.073-5.12-6.16-5.122zM127.099 24.09c0 1.093-.198 1.744-.661 2.177-.792.76-1.621.82-2.62.82-1.579 0-2.521-.78-2.521-2.087 0-1.29.921-2.06 2.462-2.06h3.34v1.15zm-3.012-9.554-.138.001h-.151c-1.193 0-1.959.15-1.966.153-1.071.202-1.589.95-1.589 2.289v.301c.549-.042 1.736-.11 3.708-.11 1.912 0 3.148 1.068 3.148 2.723v1.091h-3.924c-3.011 0-4.881 1.572-4.881 4.103 0 1.287.414 2.426 1.166 3.206.837.84 2.034 1.25 3.655 1.25 1.585 0 2.504-.36 3.514-1.37l.557-.56v1.924h3.062v-9.879c0-3.396-2.073-5.12-6.161-5.122zM139.568 26.97l-2.559-.006c-1.11 0-1.673-.574-1.673-1.707V12.021c0-1.588-1.892-1.712-2.472-1.712h-.676v15.183c0 1.866 1.078 4.045 4.118 4.045h4.652v-.522c0-.48-.1-2.045-1.39-2.045zM111.57 25.174l-3.401-10.697h-2.306l-3.37 10.702-2.673-10.702h-3.34l4.477 15.054h2.651l3.423-10.727 3.421 10.727h2.651l4.449-15.054h-3.312l-2.67 10.697z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEnglishLogo);
export default __webpack_public_path__ + "static/media/darkEnglishLogo.fd80b1847d646fc3bdd0f5a2e279c56a.svg";
export { ForwardRef as ReactComponent };